import { jsxs as e, jsx as r } from "react/jsx-runtime";

import { useMemo as t } from "react";

import { isSameDay as o, isSameHour as s, getMinutes as a } from "date-fns";

import n from "../../WeekHourSlots/index.js";

import { useLiveCurrentDate as l } from "../../../hooks/useLiveCurrentDate.js";

const i = ({hour: i, isEmpty: m}) => {
    const u = l(), p = t((() => !m && o(i, u) && s(i, u)), [ i, m, u ]), f = t((() => p ? 100 * a(u) / 60 + "%" : 0), [ u, p ]);
    return e("div", {
        className: "relative min-h-[48px] border-r border-t border-transparent group-last/row:border-b",
        children: [ !m && r(n, {
            hour: i
        }), !!p && r("span", {
            className: "pointer-events-none absolute left-0 z-10 -mt-[1px] flex h-0.5 w-full items-center bg-fuchsia-800",
            style: {
                top: f
            },
            children: r("span", {
                className: "absolute -left-1.5 h-2.5 w-2.5 rounded-full bg-fuchsia-800"
            })
        }) ]
    });
};

export { i as default };
//# sourceMappingURL=WeekCalendarHourCell.js.map
